import mapboxgl from 'mapbox-gl'
import { buildSearchString } from '@/helper/Functions'

class Layer {
  constructor (layer, map, { onClick: onClickCallback } = {}) {
    this.allowHoverState = true
    this.map = map
    this.onClickCallback = onClickCallback
    this.id = layer.id
    this.locked = layer.locked
    this.title = layer.title
    this.type = layer.type
    this.dataUrl = layer.url || ''
    if (typeof layer.mapBox !== 'undefined') {
      this.dataUrl = layer.mapBox.dataUrl
      this.visibility = layer.mapBox.visibility
      this.fillColor = layer.mapBox.fillColor
      this.opacity = parseFloat(layer.mapBox.fillOpacity)
      this.fillOutlineColor = layer.mapBox.fillOutlineColor
    }
    this.beforeLayer = undefined

    this.hoveredStateId = null
  }

  setBeforeLayer (beforeLayer) {
    this.beforeLayer = beforeLayer
  }

  getSourceId () {
    return this.id + 'Source'
  }

  getLayerId () {
    return this.id + 'Layer'
  }

  getDataUrl () {
    return this.dataUrl
  }

  addLayerAfterStyleChange (bounds) {
    this.addLayerToMap(bounds)
  }

  addLayerToMap (searchParams, beforeLayer) {
    let layerConfig = {}

    if (this.type !== 'wms') {
      this.map.addSource(this.getSourceId(), {
        'type': 'geojson',
        'data': this.dataUrl + buildSearchString(searchParams)
      })

      layerConfig = {
        'id': this.getLayerId(),
        'type': 'fill',
        // 'minzoom': 15,
        // 'maxzoom': 24,
        'source': this.getSourceId(),
        // 'source-layer': 'test',
        'layout': {
          'visibility': this.visibility || 'visible'
        },
        'paint': {
          'fill-color': this.fillColor || '#c2c0c5',
          'fill-opacity': ['case',
            ['boolean', ['feature-state', 'disabled'], false], 0,
            ['boolean', ['get', 'highlight'], false], 1,
            ['boolean', ['feature-state', 'selected'], false], 1,
            ['boolean', ['feature-state', 'hover'], false], 1, this.opacity || 0.3
          ],
          'fill-outline-color': this.fillOutlineColor || '#8b000e'
        }
      }
    } else {
      layerConfig = {
        'id': this.getLayerId(),
        'type': 'raster',
        'source': {
          'type': 'raster',
          'tiles': [
            this.dataUrl
          ],
          'tileSize': 256
        },
        'paint': {}
      }
    }

    if (beforeLayer) {
      this.map.addLayer(layerConfig, beforeLayer.getLayerId())
    } else {
      this.map.addLayer(layerConfig)
    }

    if (this.type !== 'wms') {
      this.map.on('mousemove', this.getLayerId(), this.onMouseMove)
      this.map.on('mouseleave', this.getLayerId(), this.onMouseLeave)
    }
  }

  onMouseMove = (e) => {
    if (!this.allowHoverState) {
      return
    }

    if (e.features.length > 0) {
      if (this.hoveredStateId !== null) {
        this.map.setFeatureState({ source: this.getSourceId(), id: this.hoveredStateId }, { hover: false })
      }

      this.hoveredStateId = e.features[0].id
      this.map.setFeatureState({ source: this.getSourceId(), id: this.hoveredStateId }, { hover: true })
    }
  }

  onMouseLeave = (e) => {
    if (!this.allowHoverState) {
      return
    }

    if (this.hoveredStateId !== null) {
      this.map.setFeatureState({ source: this.getSourceId(), id: this.hoveredStateId }, { hover: false })
    }
    this.hoveredStateId = null
  }

  remove () {
    this.map.removeLayer(this.getLayerId())
    if (this.type !== 'wms') {
      this.map.off('mousemove', this.getLayerId(), this.onMouseMove)
      this.map.off('mouseleave', this.getLayerId(), this.onMouseLeave)
      this.map.removeSource(this.getSourceId())
    } else {
      this.map.removeSource(this.getLayerId())
    }
  }
}

export default Layer
